// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Home from './Components/Home/Home';
import Login from './Components/Login/Login';

import ForgotPassword from './Components/Login/ForgotPassword';
import ResetPassword from './Components/Login/ResetPassword';

// Error Boundary para capturar errores de render y evitar pantalla blanca
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    justifyContent: 'center', height: '100vh',
                    fontFamily: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                    background: 'linear-gradient(135deg, #f8f7fc 0%, #ede9f6 100%)',
                    color: '#333', padding: '2rem', textAlign: 'center'
                }}>
                    {/* Icon */}
                    <div style={{
                        width: 64, height: 64, borderRadius: 16,
                        background: '#FEF2F2', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', marginBottom: 24,
                        border: '1px solid #FECACA'
                    }}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" style={{ color: '#DC2626' }}>
                            <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
                            <path d="M12 8v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <circle cx="12" cy="16" r="1" fill="currentColor" />
                        </svg>
                    </div>
                    <h2 style={{
                        marginBottom: '0.5rem', fontSize: '22px', fontWeight: 600,
                        color: '#250e48', letterSpacing: '-0.01em'
                    }}>
                        Algo salió mal
                    </h2>
                    <p style={{
                        marginBottom: '1.5rem', color: '#666', fontSize: '15px',
                        maxWidth: 400, lineHeight: 1.5
                    }}>
                        Ocurrió un error inesperado en la aplicación. Por favor recarga la página para continuar.
                    </p>
                    <button
                        onClick={() => {
                            this.setState({ hasError: false, error: null });
                            window.location.href = '/';
                        }}
                        style={{
                            padding: '12px 32px', background: '#250e48', color: '#fff',
                            border: 'none', borderRadius: '12px', cursor: 'pointer',
                            fontSize: '15px', fontWeight: 600, letterSpacing: '0.01em',
                            boxShadow: '0 4px 15px rgba(37, 14, 72, 0.25)',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => { e.target.style.background = '#7c4dff'; e.target.style.transform = 'translateY(-2px)'; }}
                        onMouseOut={(e) => { e.target.style.background = '#250e48'; e.target.style.transform = 'translateY(0)'; }}
                    >
                        Recargar página
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <Router>
                    <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/home" element={<Home />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                    </Routes>
                </Router>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;
